import { apiClient } from './client'

/** Раздел, из которого выгружена база (совпадает с EXPORT_SECTION_LABELS на api). */
export type ExportSection = 'database'

/**
 * Сообщить серверу о факте выгрузки в Excel: запись в журнал безопасности +
 * охранный алерт в Telegram. Файл собирается в браузере, поэтому без этого
 * сервер не отличает выгрузку от обычного просмотра таблицы.
 */
export async function reportDataExport(section: ExportSection, rows: number): Promise<void> {
  await apiClient.post('/security/export-events', { section, rows })
}
